"use client";

import React from "react";
import { useEffect, useRef, useState } from "react";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const industries = [{
  title: "Tiefbau & Kanalerschließung",
  image: "https://tm-bauservices.de/wp-content/uploads/2026/03/erdarbeiten.webp?v=4i51o8ix27w",
  className: "md:col-span-2"
}, {
  title: "Präzisions-Pflasterbau",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1594803/img/industry_office.png",
  className: "md:col-span-1"
}, {
  title: "Erdarbeiten & Aushub",
  image: "https://tm-bauservices.de/wp-content/uploads/2026/03/lkw-ent.png?v=ysv9itx5hpq",
  className: "md:col-span-1"
}, {
  title: "Komplette Außenanlagen",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1594803/img/industry_retail.png",
  className: "md:col-span-2"
}];
export default function SpezialisierungNachBranchen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="136044" id="echte-einblicke-in-unsere-arbeit" className="text-foreground py-24 overflow-hidden !bg-[hsl(48,96%,89%)] md:py-32">
      <div ref={ref} className={`mx-auto max-w-7xl px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-[300px] md:auto-rows-[350px]">
          {industries.map((industry, i) => <div key={i} data-index={i} className={`relative overflow-hidden rounded-sm group cursor-pointer shadow-md ${industry.className}`}>
              {}
              <img src={industry.image} alt={industry.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110 !shadow-[0px_2px_4px_rgba(20,21,31,0.15),_0px_1px_2px_rgba(20,21,31,0.10)]" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-secondary/95 via-secondary/40 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
              
              {}
              <div className="absolute bottom-0 left-0 right-0 p-8 flex flex-col justify-end h-full">
                <h3 className="font-sans font-bold text-2xl text-white translate-y-2 transition-transform duration-500 group-hover:translate-y-0 tracking-tight uppercase">
                  {industry.title}
                </h3>
                {}
                <div className="h-1 w-12 bg-primary mt-4 opacity-0 transition-all duration-500 group-hover:opacity-100 group-hover:w-20 shadow-[0_0_10px_rgba(249,115,22,0.5)]" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}